<template>
    <v-app> 
         <Tabs :routes='route' :colors="colors.colors.panel1" />
            <v-container>
                <transition name="slide-fade">
                 <router-view></router-view>
                </transition>
            </v-container>
    </v-app>
</template>
<script>

import Tabs from '../../component/layouts/content/tabs'
import color from '../../../../plugins/assets/colors'

export default {
    
    components:{
        Tabs
    },

    mounted() {
        
        this.inicioDeRegistro(); 
        
    },

    destroyed() {
       // this.switchs = false;
    },

    data(){
        return {

            switchs:true,
            colors:color,
            route:[
                {
                    id:1,
                    name:'Lista de registro',
                    icon:'mdi-table-large',
                    route:'/registro',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Registro',
                        disabled: true,
                        href: 'Registro',
                        },
                        
                    ],
                
                },

                {
                    id:2,
                    name:'Crear registro nuevo',
                    icon:'mdi-plus-circle',
                    route:'/registro/crear',
                    items: [
                        {
                        text: 'Inicio',
                        disabled: false,
                        href: '/',
                        },
                        {
                        text: 'Registro',
                        disabled: false,
                        href: '/registro',
                        },
                        {
                        text: 'Crear',
                        disabled: true,
                        href: '/registro/crear',
                        },
                        
                    ],

                },

                
            ]



        }
    },

    computed: {
        
        fechafilter(){
            return this.$store.state.fecha_filter;
        }

    },

    methods: {
        repetidor:function(){
            //console.log(this.$route.path)
            if (this.$route.path == '/registro') {
                this.MethodsReload();  
            }
        },

        MethodsReload:function(){
            setTimeout(() => {
                this.$store.dispatch('GetRegListas', this.fechafilter);
                this.repetidor();
            }, 3000);
        },


       async inicioDeRegistro (){
            await this.$store.dispatch('GetRegListas', this.fechafilter);
            await this.$store.dispatch('GetSucursal');
            await this.$store.dispatch('GetAsign');
            await this.$store.dispatch('GetDrivings');
            await this.$store.dispatch('GetVehicles');
            await this.$store.dispatch('GetEmpresas');
            await this.repetidor();
        }

    


    },


}
</script>